import React from 'react';
import { createRoot } from 'react-dom/client';
import LoginGate from './components/LoginGate';

import 'drag-drop-touch';
import '@fontsource/source-sans-pro';
import './index.css';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<LoginGate />);
